import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Task } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '../../../helper'

const log = new Logger('TaskManagerService')

/**
 * Đây là services dành cho Planner
 */

@Injectable({ providedIn: 'root' })
export class TaskManagerService {
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng cho User
   */
  private _apiPath = {
    list: 'manager/task_entity',
    detail: 'manager/task_entity',
  }

  getAll(params?: any): Observable<any> {
    // let pa = new HttpParams();
    let pa = new HttpParams().set(
      'parameters[task_business_id]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }
    return this.apiService.get<any>(this._apiPath.list, pa).pipe(
      map(data => {
        return data
      })
    )
  }

  getDetail(id: string): Observable<Task> {
    return this.apiService.get<Task>(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        return data
      })
    )
  }

  create(res): Observable<any> {
    res.tid = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        return data
      })
    )
  }

  edit(res: Task): Observable<any> {
    return this.apiService.put(`${this._apiPath.detail}/${res.tid}`, res).pipe(
      map(data => {
        return data
      })
    )
  }

  delete(tid): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${tid}`).pipe(
      map(data => {
        return data
      })
    )
  }
}
